import { useState } from 'react';

export const menuItems = [
  { label: 'Home', href: '/' },
  { label: 'Shop', href: '/products', children: [
    { label: 'All Products', href: '/products' },
    { label: 'Best Sellers', href: '/collections/best-sellers' },
    { label: 'New Arrivals', href: '/collections/new-arrivals' },
  ] },
  { label: 'Dog Supplements', href: '/collections/supplements', children: [
    { label: 'All Supplements', href: '/collections/supplements' },
    { label: 'Daily Wellness', href: '/collections/supplements/daily-wellness' },
    { label: 'Joint Support', href: '/collections/supplements/joint-support' },
  ] },
  { label: 'Pet Care', href: '/collections/pet-care', children: [
    { label: 'Grooming', href: '/collections/grooming' },
    { label: 'Care Essentials', href: '/collections/pet-care/essentials' },
    { label: 'Wellness Tips', href: '/blog/wellness-tips' },
  ] },
  { label: 'About Us', href: '/about' },
  { label: 'Resources', href: '/blog' },
];

export default function NavMenu() {
  const [openMenu, setOpenMenu] = useState(null);
  return <nav className="desktop-nav" aria-label="Main navigation"><ul className="nav-list">
    {menuItems.map(item => <li className="nav-item" key={item.label} onMouseEnter={() => setOpenMenu(item.label)} onMouseLeave={() => setOpenMenu(null)}>
      {item.children ? <>
        <button className="nav-link nav-link--button" type="button" aria-expanded={openMenu === item.label} onClick={() => setOpenMenu(openMenu === item.label ? null : item.label)}>
          {item.label}
        </button>
        <div className={openMenu === item.label ? 'dropdown dropdown--open' : 'dropdown'}><ul>
          {item.children.map(child => <li key={child.label}><a href={child.href} onClick={() => setOpenMenu(null)}>{child.label}</a></li>)}
        </ul></div>
      </> : <a className={item.label === 'Home' ? 'nav-link nav-link--home' : 'nav-link'} href={item.href}>{item.label}</a>}
    </li>)}
  </ul></nav>;
}
